import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'app/services/header/header.service';
import { ToastrService } from 'ngx-toastr';
import { LogicielCaisseAuthService } from 'app/services/logiciel-caisse/logiciel-caisse-auth.service';
import {
  AccesLogicielCaisseService,
} from 'app/services/logiciel-caisse/acces-logiciel-caisse.service';
import { readObservableError } from 'app/services/logiciel-caisse/logiciel-caisse-api.helper';

@Component({
  selector: 'app-acces-logiciel-caisse-connexion',
  templateUrl: './acces-logiciel-caisse-connexion.component.html',
  styleUrls: ['./acces-logiciel-caisse-connexion.component.scss'],
})
export class AccesLogicielCaisseConnexionComponent implements OnInit {
  returnUrl = '/tiers/ticketCaisse/tous';
  code_station = '';
  email = '';
  password = '';
  isSubmitting = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly headerService: HeaderService,
    private readonly lcAuth: LogicielCaisseAuthService,
    private readonly accesService: AccesLogicielCaisseService,
    private readonly toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const ctx = this.lcAuth.getErpContext();
    if (!ctx) {
      void this.router.navigate(['/pages/authentication/login-v2']);
      return;
    }
    this.code_station = ctx.code_station;
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/tiers/ticketCaisse/tous';
    this.headerService.setConfig({ title: 'Connexion logiciel caisse', buttons: [] });

    this.accesService.listByCodeStation(this.code_station).subscribe({
      next: (rows) => {
        const row = rows.find((r) => r.is_active !== false) ?? rows[0];
        if (row?.email) {
          this.email = row.email;
        }
      },
    });
  }

  retour(): void {
    void this.router.navigate(['/tiers/acces-logiciel-caisse'], {
      queryParams: { returnUrl: this.returnUrl },
    });
  }

  submit(): void {
    if (!this.password || this.password.length < 6) {
      this.toastr.warning('Mot de passe requis (6 caractères minimum).', 'Connexion');
      return;
    }
    this.isSubmitting = true;
    this.lcAuth.loginWithCredentials(this.email, this.password, this.code_station).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.toastr.success('Connexion au logiciel caisse établie.', 'Tickets');
        void this.router.navigateByUrl(this.returnUrl);
      },
      error: (err) => {
        this.isSubmitting = false;
        this.toastr.error(
          readObservableError(err, 'Connexion logiciel caisse impossible.'),
          'Erreur'
        );
      },
    });
  }
}
